<template lang="pug">
v-layout(row wrap v-if="value && value.children.length")
  v-flex(v-for="child, childI in value.children" :key="childI" :class="`${child.widths.join(' ')} ${border ? 'layout-tree--border' : ''}`")
    slot(:item="child" :itemI="childI" :parent="value" :depth="depthParent")
    layout-tree(:value="child" :depthParent="depthParent + 1" v-if="child.children.length" :border="border")
      slot(slot-scope="scope" v-bind="scope")

</template>

<style lang="stylus" scoped>
.layout-tree--border
  box-shadow 0 0 0 1px grey

</style>

<script>
export default {
  name: 'layout-tree',
  props: {
    value: Object,
    border: Boolean,
    depthParent: {
      type: Number,
      default: 0
    }
  },
}
</script>
